exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#modalCreateGroup .profileImage{height:60px;line-height:60px;width:60px;margin-left:50%;transform:translateX(-50%);margin-bottom:20px}", "", {"version":3,"sources":["C:/Users/fpluq/Projects/groopus-vue/src/components/GroupManagement/NewGroup.vue"],"names":[],"mappings":"AACA,gCACE,YAAa,AACb,iBAAkB,AAClB,WAAY,AACZ,gBAAiB,AACjB,2BAA4B,AAC5B,kBAAoB,CACrB","file":"NewGroup.vue","sourcesContent":["\n#modalCreateGroup .profileImage {\n  height: 60px;\n  line-height: 60px;\n  width: 60px;\n  margin-left: 50%;\n  transform: translateX(-50%);\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2b55acae","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/GroupManagement/NewGroup.vue
// module id = 1080
// module chunks = 1